/**
 * Created by khanhduong on 11/7/17.
 */

import * as types from '../constants/actionTypes';
import {
  SUBSCRIPTION_TYPE,
  FaceIDShow,
  FaceIDDelay,
  MESSAGE_IMAGE_DURATION_ENUM,
  DEFAULT_FOLDER_OPTION,
  THEMES,
  FONT_SIZES,
  ACCOUNT_STATUS,
  MEMBER_TYPES,
  MEMBER_LEVEL,
} from '../constants/constants';
import { ILoginState } from '../types/login';
import Immutable from 'seamless-immutable';
import { WebIM } from 'redhotpie-shared-lib/sdks/src/connection.ts';
import { ImmutableObject } from 'seamless-immutable';
import { register } from '../actions/loginActions';
import { IUserLoginInfo } from 'redhotpie-shared-lib/interfaces/IUser';
import { MEMBER } from 'redhotpie-shared-lib/constants/routes';

export interface IPayloadLogin {
  userName?: string;
  password?: string;
  rhpUserName?: string;
  rhpPassword?: string;
  userInfo?: Partial<IUserLoginInfo>;
}

export interface IPayloadRegister {
  userName?: string;
  password?: string;
}

interface IAction {
  login: IPayloadLogin;
  register: IPayloadRegister;
  type: string;
  msg: string;
  currentConnectionStatus: number;
  data: any;
  error: any;
  isReconnecting: boolean;
  userInfo: Partial<IUserLoginInfo>;
  toolTipId: number;
  dataKey: string[];
}

const initLoginReducerState: ImmutableObject<ILoginState> = Immutable({
  isStreaming: false,
  timestampUpdate: 0,
  APIMatchingLoaded: false,
  isLogin: false,
  isLoginOut: false,
  userName: '',
  jIdResource: '',
  xmppId: '',
  rhpUserName: '',
  rhpPassword: '',
  password: '',
  error: null,
  msg: '',
  fetching: false,
  registerError: null,
  userInfo: {
    accountStatus: ACCOUNT_STATUS.ACTIVE,
    userId: 0,
    accountPaused: false,
    isLoadingUserSettings: false,
    isIgnoreConversationEnabled: false,
    messenger: {
      isLoading: false,
      defaultFolder: DEFAULT_FOLDER_OPTION.ALL,
      defaultImageDuration: MESSAGE_IMAGE_DURATION_ENUM.THREE_MONTHS,
      theme: {
        darkMode: false,
        theme: THEMES.GREEN,
        fontSize: FONT_SIZES.MEDIUM,
        themeType: THEMES.GREEN,
        darkModeSetting: 'Off',
      },
      canReceivePhotos: false,
      canReceiveGifts: false,
      isActive: false,
      permissionMessageReceive: '',
      permissionVideoCall: '',
      replyLimitDays: 0,
    },
    ageTitle: '',
    chatroomSettings: {},
    toolTips: [],
    isInLiveStream: false,
    isVideoCall: false,
    fromUserJid: '',
    isLoadedUserInfo: false,
    profileBoostExpiry: 0,
    lastBoostedConversationTime: {},
    xmppId: '',
    online: false,
    safeMode: false,
    isSpotlightFeatureEnabled: false,
    accountRequiresAuthentication: false,
    newPasswordRequired: false,
    isImageReplyEnabled: false,
    fileUploadLimit: 0,
    streamSettings: {} as any,
    country: {} as any,
    accountDeleteDate: '',
    displayName: '',
    memberType: 0,
    old: 0,
    location: {} as any,
    memberLevel: MEMBER_LEVEL.GUEST,
    memberLevelExpiry: 0,
    detailInfo: {},
    tempInfo: {},
    isCouple: false,
    memberTypeTitle: {} as any,
    verificationState: 'Pending',
    emailAddress: '',
    usernameRejected: false,
    recurringStatus: {},
    activeProducts: [],
    memberLevelValue: MEMBER_TYPES.GUEST,
    isViewable: false,
    isPublic: false,
    imageType: '',
    mainPhotoRestricted: false,
    client: {} as any,
    grants: {} as any,
    notificationSettings: {} as any,
    emailNotificationSettings: {} as any,
    accountSettings: {} as any,
    linkedAccounts: {} as any,
    avatarUrl: '',
    avatarFullUrl: '',
    created_at: '',
    id: 0,
    firstName: '',
    lastName: '',
    sex: '',
    pinned: [],
    favorites: [],
    isMatch: false,
    isFavorited: false,
    isFavoritedMutual: false,
    clubMemberType: '',
    bannedFromPosting: false,
    isLiked: false,
    isLikedMutual: false,
    isIgnored: false,
    isVerified: false,
    isBlocked: false,
    isDiamond: false,
    hasMessage: false,
    dealBreakerConflict: [],
    dealBreakerConflictViewer: [],
    matching: [],
    classIfication: 0,
    userType: '',
    isWhisperMessage: false,
    profileIntersection: {} as any,
    isUserImage: false,
    mainPhotoSummary: {} as any,
    mainPhoto: {} as any,
    stateId: null,
    countryId: null,
    memberTypeId: null,
    birthday1: null,
    birthday2: null,
    age1: null,
    age2: null,
    userName: '',
    isOnline: false,
    isMatching: false,
    parentGroup: { id: 0, name: '' },
    isAdmin: false,
    matchingInterests: null,
    countryID: undefined,
    memberID: undefined,
    memberLevelType: undefined,
    memberLevelUserProfile: undefined,
    loginToken: undefined,
    isOnlineUpdateTime: undefined,
    dateListItem: undefined,
    creditCardInfo: undefined,
    locationInfo: undefined,
    userPhone: undefined,
  },
  userStatus: {},
  matchingUsers: [],
  userProfile: {},
  isLoginFb: false,
  isResetPassword: false, //
  reconnecting: true,
  connectionStatus: WebIM.statusCode.STATUS_INIT,
  firstCallApis: true,
  phoneNumberCountryCode: {
    name: 'Afghanistan',
    dial_code: '+93',
    code: 'AF',
    latitude: 33,
    longitude: 65,
  },
  isOpenWS: true,
  isLoginXmpp: true,
  gettingUserXmppDetail: false,
});

export default function loginReducer(state = initLoginReducerState, action: IAction): ImmutableObject<ILoginState> {
  switch (action.type) {
    case types.USER_LOGIN_SUCCESS: {
      return state.merge({
        fetching: false,
        error: null,
        msg: action.msg,
        isLogin: true,
        isLoginOut: false,
        timestampUpdate: new Date().getTime(),
      });
    }

    case types.UPDATE_LOGIN_REDUCER_STATE:
      return state.merge({ ...action.data });

    case types.USER_REQUEST_LOGIN: {
      return state.merge({
        // fetching: true, // Comment as by NhatDo suggest
        error: null,
        userName: action.login?.userName,
        password: action.login?.password,
        rhpUserName: action.login?.rhpUserName,
        rhpPassword: action.login?.rhpPassword,
      });
    }

    case types.USER_LOGIN_FAIL: {
      // return state.merge({fetching: false, error: action.error, isLogin: false, msg: action.msg});
      // state = state.set('fetching', false);
      // state = state.set('error', action.error);
      // state = state.set("msg",action.msg);
      // state = state.set('isLogin', false);
      // return state;
      return state.merge({
        fetching: false,
        error: action.error,
        isLogin: false,
        msg: action.msg,
      });

      // return Object.assign({}, state, {fetching: false, error: action.error, isLogin: false, msg: action.msg});
    }
    case types.UPDATE_CONNECTION_STATUS: {
      return state.merge({ connectionStatus: action.currentConnectionStatus });
    }
    case types.ATTEMPT_CONNECT_SUCCESS: {
      return state.merge({ reconnecting: action.isReconnecting });
    }
    case types.UPDATE_ERROR_STATUS_LOGIN: {
      return state.set('error', action.data);
    }

    // --------------case for register-------------
    case types.USER_REGISTER_SUCCESS: {
      return state.merge({
        fetching: false,
        error: null,
        userName: action.register.userName,
        password: action.register.password,
      });
    }
    case types.USER_REQUEST_REGISTER: {
      return state.merge({
        fetching: true,
        error: null,
        userName: action.register.userName,
        password: action.register.password,
      });
    }

    case types.USER_REGISTER_FAIL: {
      return state.merge({ fetching: false, error: action.error });

      // return Object.assign({}, state, {fetching: false, error: action.error});
    }

    case types.USER_REQUEST_USER_LOGIN_INFO_SUCCESS: {
      return state.set('userInfo', { ...state.userInfo.asMutable({ deep: true }), ...action.login.userInfo });
    }
    case types.USER_UPDATE_INFO_SUCCESS: {
      const { userInfo } = state;
      let updateTokenTemp = null;
      let productTokenTemp = null;
      if (userInfo && userInfo.creditCardInfo) {
        updateTokenTemp = userInfo.creditCardInfo.updateToken;
        productTokenTemp = userInfo.creditCardInfo.productToken;
      }
      state = state.set('userInfo', { ...userInfo.asMutable({ deep: true }), ...action.userInfo });
      if (updateTokenTemp) {
        state = state.setIn(['userInfo', 'creditCardInfo', 'updateToken'], updateTokenTemp);
      }
      if (productTokenTemp) {
        state = state.setIn(['userInfo', 'creditCardInfo', 'productToken'], productTokenTemp);
      }
      return state;
    }

    case types.UNPAUSE_ACOUNT: {
      return state.setIn(['userInfo', 'accountPaused'], false);
    }

    case types.GET_PROFILE_SUCCESS: {
      return state.set('userProfile', action.data);
    }

    case types.GET_MATCHING_USERS_SUCCESS: {
      return state.set('matchingUsers', action.data).set('APIMatchingLoaded', true);
    }

    case types.ADD_MATCHING_USER_SUCCESS: {
      const _matchingUsers = state.matchingUsers.asMutable() || [];
      const matchingUser = _matchingUsers.filter(userId => userId === action.data);
      if (!(matchingUser && matchingUser.length > 0)) {
        _matchingUsers.push(action.data);
      }
      return state.set('matchingUsers', _matchingUsers);
    }

    case types.UPDATE_STATUS_LOGIN_FB: {
      return state.set('isLoginFb', action.data);
    }

    case types.REQUEST_FORGOT_PASSWORD_SUCCESS: {
      return state.set('isResetPassword', action.data);
    }

    case types.UPDATE_USER_STATUS: {
      return state.set('userStatus', action.data);
    }

    case types.UPDATE_USER_LOGIN_STATE: {
      //    console.log(action)
      return state.setIn([...action.data.dataKey], action.data.dataValue);
    }

    case types.UPDATE_MESSENGER_PERMISSION_REQUEST: {
      return state.setIn(['userInfo', 'messenger', 'isLoading'], true);
    }

    case types.UPDATE_MESSENGER_PERMISSION_FAILED: {
      return state.setIn(['userInfo', 'messenger', 'isLoading'], false);
    }

    case types.UPDATE_MESSENGER_PERMISSION_SUCCESS: {
      return state
        .setIn([...action.data[0].dataKey], action.data[0].dataValue)
        .setIn([...action.data[1].dataKey], action.data[1].dataValue)
        .setIn([...action.data[2].dataKey], action.data[2].dataValue)
        .setIn([...action.data[3].dataKey], action.data[3].dataValue)
        .setIn([...action.data[4].dataKey], action.data[4].dataValue)
        .setIn([...action.data[5].dataKey], action.data[5].dataValue)
        .setIn([...action.data[6].dataKey], action.data[6].dataValue)
        .setIn(['userInfo', 'messenger', 'isLoading'], false);
    }

    case types.UPDATE_CHATROOM_MESSENGER_PERMISSION_SUCCESS: {
      state = state.setIn([...action.data[1].dataKey], action.data[1].dataValue);
      return state.setIn([...action.data[0].dataKey], action.data[0].dataValue);
    }

    case types.FIRST_CALL_API: {
      return state.set('firstCallApis', false);
    }

    case types.GET_JIDRESOURCE_SUCCESS: {
      return state.set('jIdResource', action.data);
    }

    case types.USER_LOGOUT_SUCCESS: {
      return initLoginReducerState;
    }
    case types.POST_VERIFICATION_SUCCESS: {
      return state.setIn(['userInfo', 'verificationState'], 'Pending');
    }

    case types.SET_STATUS_USER_IN_LIVE_STREAM: {
      return state.setIn(['userInfo', 'isInLiveStream'], action.data);
    }

    case types.UPDATE_IS_STREAMING: {
      return state.set('isStreaming', action.data);
    }

    case types.SET_STATUS_USER_IN_VIDEO_CALL: {
      return state.setIn(['userInfo', 'isVideoCall'], action.data);
    }

    case types.CREATE_USER_TOOLTIP_SUCCESS: {
      const { toolTips } = state.userInfo;
      if (toolTips) {
        let toolTip = toolTips.find(e => e.id === action.toolTipId);
        let newToolTips = [];
        if (toolTip) {
          newToolTips = toolTips.asMutable().map(e => {
            if (e.id === action.toolTipId) {
              return { ...toolTip, display: false };
            }
            return e;
          });
          return state.setIn(['userInfo', 'toolTips'], newToolTips);
        }
      }
      return state;
    }

    case types.INCREASE_TOOLTIP_VIEW_COUNT_FACE_ID: {
      const { toolTips } = state.userInfo;
      if (toolTips) {
        let toolTip = toolTips.find(e => e.id === action.toolTipId);
        let newToolTips = [];
        if (toolTip) {
          newToolTips = toolTips.asMutable().map(e => {
            if (e.name === FaceIDShow || e.name === FaceIDDelay) {
              return { ...toolTip, ViewCount: e.ViewCount + 1 };
            }
            return e;
          });
          return state.setIn(['userInfo', 'toolTips'], newToolTips);
        }
      }
      return state;
    }

    case types.UPDATE_RETAIN_STATUS_SUCCESS: {
      const filterUpdate = ['userInfo', 'recurringStatus'];
      if (action.data.type === SUBSCRIPTION_TYPE.VEROTEL) {
        filterUpdate.push('isRecurring');
      } else {
        filterUpdate.push('isRecurringCancelPending');
      }
      return state.setIn(filterUpdate, action.data.enableRecurring);
    }

    case types.UPDATE_LOGIN_STATE: {
      return state.setIn([...action.data.key], action.data.value);
    }

    case types.USER_UPDATE_JID: {
      return state.setIn(['userInfo', 'fromUserJid'], action.data);
    }

    case types.GET_PAYMENT_SUCCESS: {
      state = state.setIn(['userInfo', 'creditCardInfo', 'updateToken'], action.data.data.updateToken);
      state = state.setIn(['userInfo', 'creditCardInfo', 'productToken'], action.data.data.productToken);
      return state;
    }

    case types.UPDATE_STATE_USER_LOGIN: {
      return state.setIn([...action.dataKey], action.data);
    }

    default:
      return state;
  }
}
